import { Box, Typography } from "@material-ui/core"
import React from "react"

interface LegendItemProps {
  color: string
  label: string
  percentage: string
  count: number
}

const LegendItem: React.FC<LegendItemProps> = ({ color, label, percentage, count }) => {
  return (
    <Box display="flex" mt={1} mr={2}>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box width="16px" height="16px" bgcolor={color} mr={1} borderRadius="4px" />
        <Typography variant="body2">
          {label}
          <span style={{ marginLeft: "4px" }}>
            {percentage}% ({count})
          </span>
        </Typography>
      </Box>
    </Box>
  )
}

export default LegendItem
